import objectToArray from '@utils/objectToArray'
import arrayToObject from '@utils/arrayToObject'
import _cloneDeep from 'lodash/cloneDeep'

function formatWidgetForApi(widget) {
  // Deep clone the widget to avoid mutating the original state
  const formattedWidget = _cloneDeep(widget)

  // Convert steps from object to array
  const widgetSteps = objectToArray(formattedWidget.steps,
    formattedWidget.stepsList)
  formattedWidget.steps = widgetSteps
  delete formattedWidget.stepsList

  // Iterate over each step to convert contentItems from object to array
  widgetSteps.forEach((step, index) => {
    const widgetContentItems = objectToArray(step.contentItems,
      step.contentItemsList)
    formattedWidget.steps[index].contentItems = widgetContentItems
    delete formattedWidget.steps[index].contentItemsList
  })

  return formattedWidget
}

function formatWidgetFromApi(widget) {
  // Ensure widget is a shallow copy to avoid direct mutations
  const formattedWidget = { ...widget }

  // Convert steps from array to object and generate stepsList
  const stepsObj = arrayToObject(formattedWidget.steps, 'id')
  formattedWidget.steps = stepsObj
  formattedWidget.stepsList = Object.keys(stepsObj)

  // Iterate over each step
  Object.values(formattedWidget.steps).forEach(step => {
    // Convert contentItems from array to object and generate contentItemsList
    const contentItemsObj = arrayToObject(step.contentItems, 'id')
    step.contentItems = contentItemsObj
    step.contentItemsList = Object.keys(contentItemsObj)
  })

  return formattedWidget
}

export { formatWidgetForApi, formatWidgetFromApi }